exports.log = function (activityToken, config) {
    try {
        if (process.env.NODE_ENV === 'development') {
            fetch(config.url + '/' + config.pt + '/' + activityToken + '/' + config.u);
        }
    } catch (e) {
    }
};